import React from "react";
import * as SC from "./CampaignDuration.styled";
import DurationArrow from "../../../../../../images/dataViz/durationArrow.svg";
import Section from "../Section/Section";
import useCampaignDuration from "../../hooks/useCampaignDuration";
import moment from "moment";

const CampaignDuration = ({ campaignLiveDate, endDate }) => {
  const { dateFormat } = useCampaignDuration();

  const timestampEndDate = new Date(endDate).getTime();

  const startDateFormatted = dateFormat(campaignLiveDate);
  const endDateFormatted = dateFormat(timestampEndDate);
  const remainingDays = moment(timestampEndDate).diff(moment(), "days") + 1;
  const totalDays = moment(timestampEndDate).diff(moment(campaignLiveDate), "days") + 1;

  const percentageProgress = (1 - remainingDays / totalDays) * 100;

  return (
    <SC.Wrapper>
      <SC.SectionWrapper>
        <Section title={"Start"}>
          <div>{startDateFormatted}</div>
        </Section>
        <Section>
          <SC.ArrowSection>
            <DurationArrow />
          </SC.ArrowSection>
        </Section>
        <Section title={"End"}>
          <div>{endDateFormatted}</div>
        </Section>
      </SC.SectionWrapper>
      <SC.ProgressBarContainer>
        <SC.ProgressBarInner percentageProgress={percentageProgress} />
      </SC.ProgressBarContainer>
    </SC.Wrapper>
  );
};

export default CampaignDuration;
